import React from 'react';

export function GradientText({ children, variant = 'hash', className = '', as: Tag = 'span' }) {
  const gradients = {
    hash: 'from-[#f7ec9c] via-[#eed45b] to-[#93611a]',
    medora: 'from-[#63c6ef] via-[#11acec] to-[#0a3c79]',
    gold: 'from-[#FFD700] via-[#D4AF37] to-[#B8860B]',
  };

  return (
    <Tag className={`relative inline-block ${className}`}>
      {/* Shadow layer underneath */}
      <span
        className="absolute inset-0 select-none pointer-events-none flex items-center justify-center"
        style={{
          color: 'transparent',
          textShadow: '0 2px 8px rgba(0,0,0,0.9), 0 0 30px rgba(0,0,0,0.7)',
        }}
        aria-hidden="true"
      >
        {children}
      </span>
      {/* Gradient layer on top */}
      <span className={`relative z-10 bg-gradient-to-b ${gradients[variant] || gradients.hash} bg-clip-text text-transparent`}>
        {children}
      </span>
    </Tag>
  );
}

export default GradientText;
